export default __webpack_public_path__ + "712cbcd3925070a33e3c9d896f7e1f8f.gif";